export default __webpack_public_path__ + "images/8e9fad791e13b97ac50173323626e2ef.svg";